import axiosInstance from '../app/axios';

export const paymentAPI = {
  getStatus: async (orderId) => {
    const response = await axiosInstance.get(`/payments/status/${orderId}`);
    return response.data;
  },
};

export default paymentAPI;
